<template>
	<v-form ref="unitary_form">
		<v-layout row justify-center>
			<v-flex>
				<v-card color="background darken-1 elevation-0">
					<v-card-text class="pa-0">
						<v-stepper v-model="step" vertical class="background darken-1 elevation-0">

							<v-stepper-step
								:editable="step > 1"
								:complete="step > 1"
								step="1"
								color="primary color--text">
								<span class="subheading">Choix du répertoire</span>
								<small v-if="form.parameters.directory" class="primary--text">
									<v-icon small color="primary">arrow_forward</v-icon>
									{{ form.parameters.directory }}
								</small>
							</v-stepper-step>
							<v-stepper-content step="1" class="pt-0">
								<v-text-field
									solo
									class="grv-input"
									readonly
									:rules="[checkRequired]"
									name="Répertoire source"
									append-icon="folder_open"
									@click:append="showExplorer = true"
									v-model="form.parameters.directory">
								</v-text-field>
								<v-btn
									color="primary color--text"
									class="text-none ml-0"
									:disabled="!form.parameters.directory"
									@click="step = 2">
									Continuer
								</v-btn>
							</v-stepper-content>

							<v-stepper-step
								:editable="step > 2"
								:complete="step > 2"
								color="primary color--text"
								step="2">
								<span class="subheading">Choix de la référence SUIFA</span>
								<small v-if="form.parameters.suifa_ref" class="primary--text">
									<v-icon small color="primary">arrow_forward</v-icon>
									{{ form.parameters.suifa_ref }}
								</small>
							</v-stepper-step>
							<v-stepper-content step="2" class="pt-0">
								<v-text-field
									solo
									class="grv-input"
									:rules="[checkRequired, checkRefSuifa]"
									name="Référence SUIFA"
									:loading="suifaInfos.loading"
									v-model="form.parameters.suifa_ref"
									@change="getBehiveAssetInfo(form.parameters.suifa_ref)">
									<v-tooltip
										slot="append"
										bottom>
										<v-btn
											@click="getBehiveAssetInfo(form.parameters.suifa_ref)"
											icon
											small
											:disabled="!form.parameters.suifa_ref"
											:loading="suifaInfos.loading"
											slot="activator">
											<v-icon>search</v-icon>
										</v-btn>
										Get data from Behive/Suifa
									</v-tooltip>
								</v-text-field>

								<div v-if="errors">
									<div v-for="error in errors" :key="error.id">
										<p class="error--text">{{ error }}</p>
									</div>
								</div>

								<table v-if="suifaInfos.data" class="info-table">
									<tbody>
										<tr v-if="suifaInfos.data.type_sup">
											<th>Asset type</th>
											<td>{{ suifaInfos.data.type_sup.code_type_sup }}</td>
										</tr>
										<tr v-if="suifaInfos.data.titre">
											<th>Titre</th>
											<td>{{ suifaInfos.data.titre.titre_princ }}</td>
										</tr>
										<tr v-if="suifaInfos.data.asset_size">
											<th>Poids</th>
											<td>
												<span v-if="String(suifaInfos.data.asset_size).length < 10" class="mb-1">
													- {{ $weight.bitRoundToTwo(suifaInfos.data.asset_size, 2) }} Mo
												</span>
												<span v-else class="mb-1">
													- {{ $weight.bitRoundToTwo(suifaInfos.data.asset_size, 3) }} Go
												</span>
											</td>
										</tr>
										<tr v-if="suifaInfos.data.t_aux_proprio">
											<th>Ayant droit</th>
											<td>{{ suifaInfos.data.t_aux_proprio.t_libelle }} - ({{ suifaInfos.data.t_aux_proprio.t_auxiliaire }})</td>
										</tr>
										<tr>
											<th>Contrat catalogue</th>
											<td>
												<v-icon v-if="localHasContract" color="green accent-3">
													task_alt
												</v-icon>
												<v-icon v-else color="red">block</v-icon>
											</td>
										</tr>
									</tbody>
								</table>

								<v-btn
									color="primary color--text"
									class="text-none"
									:disabled="errors.length > 0 || !suifaInfos.data"
									@click="step = 3">
									Continuer
								</v-btn>
							</v-stepper-content>

							<v-stepper-step
								color="primary color--text"
								step="3">
								<span class="subheading">Confirmation et stockage</span>
								<small>Veuillez vérifier les informations entrées</small>
							</v-stepper-step>
							<v-stepper-content step="3" class="pt-0">

								<table v-if="suifaInfos.data" class="info-table">
									<tbody>
										<tr>
											<th>Répertoire sélectionné</th>
											<td>{{ form.parameters.directory }}</td>
										</tr>
										<tr>
											<th>référence SUIFA</th>
											<td>{{ form.parameters.suifa_ref }}</td>
										</tr>
										<tr>
											<th>T aux</th>
											<td>{{ suifaInfos.data.t_aux_proprio.t_libelle }}</td>
										</tr>
										<tr>
											<th>Titre</th>
											<td>{{ suifaInfos.data.titre.titre_princ }}</td>
										</tr>
										<tr>
											<th>Type programme</th>
											<td>{{ suifaInfos.data.programme.type_prgm.lib_type_prgm }}</td>
										</tr>
									</tbody>
								</table>

								<div v-if="$user.isAdmin()">
									<tree-view
										v-if="manifest"
										:data="manifest"
										:options="{rootObjectKey: 'manifest'}">
									</tree-view>
									<br/>
								</div>

								<v-layout row wrap class="ma-0">
									<v-flex xs6>
										<v-select
											solo
											dense
											flat
											label="Type de stockage"
											class="grv-input"
											:rules="[checkRequired]"
											name="Type de stockage"
											:menu-props="{contentClass: 'grv-menu'}"
											prepend-inner-icon="archive"
											:items="storage_list"
											v-model="form.parameters.server_storage">
										</v-select>
									</v-flex>
									<v-flex xs6>
										<v-checkbox
											hide-details
											label="Supprimer la source"
											name="Supprimer la source"
											color="primary"
											class="mb-2 pl-2 grv-input"
											v-model="form.parameters.remove_source">
										</v-checkbox>
									</v-flex>
								</v-layout>
							</v-stepper-content>

						</v-stepper>
					</v-card-text>
				</v-card>
			</v-flex>

			<Explorer
				v-if="showExplorer"
				:shortcuts="explorer.shortcuts"
				:assetType="explorer.assetType"
				:multiselect="false"
				@close="showExplorer = false"
				@selectedAssets="onSelectDir($event)">
				<h3 slot="header">Asset Select for Maestro ingester</h3>
			</Explorer>

		</v-layout>
	</v-form>
</template>

<script>
import Explorer from '@/components/modal_explorer.vue'
const REF_SUIFA_REGEXP = /[0-9]{2}\/[0-9]{2}\/[a-zA-Z0-9]{4}/g

export default {
	components: {
		Explorer
	},
	props: ['param', 'wf_data', 'form'],
	data () {
		return {
			behiveCat: ['data'],
			suifaInfos: {
				ref: null,
				data: null,
				loading: false
			},
			manifest: null,
			jobTypes: ['FDVD', 'FBD'],
			errors: [],
			step: 1,
			showExplorer: false,
			explorer: {
				shortcuts: [
					{ text: '1305j552 - Bluray', value: '//1305j552/dvd/ARCHIVAGE/BD/1_A_FAIRE' },
					{ text: '1305j552 - Dvd', value: '//1305j552/dvd/ARCHIVAGE/DVD/1_A_FAIRE/3_SUR_SERVEUR' }
				],
				assetType: 'folder'
			},
			localHasContract: false
		}
	},
	computed: {
		storage_list () {
			if (this.wf_data) {
				let param = this.wf_data.parameters.find(param => {
					return param.name === 'server_storage'
				})
				if (param) return param.choices
			}
			return []
		}
	},

	methods: {
		init () {
			if (this.param) {
				if (this.param.type.indexOf('folder') > -1) {
					this.form.parameters.directory = this.param.value + '/'
				}
			}
		},

		onSelectDir (evt) {
			this.form.parameters.directory = this.$paths.UNCToMaestro(evt.path) + '/'
			setTimeout(() => { this.step = 2 }, 500)
		},

		getTAuxContract (tAux) {
			return new Promise((resolve, reject) => {
				this.$apiPublic.contract_search(tAux)
					.then(response => {
						resolve(response)
					})
					.catch(error => {
						console.error(error)
						reject(error)
					})
			})
		},

		getAssetInfo (ref) {
			return new Promise((resolve, reject) => {
				let params = {
					ref_materiel: ref,
					per_page: 100
				}
				this.$apiPublic.material_search(params, true)
					.then(response => {
						resolve(response)
					})
					.catch(err => {
						console.error(err)
						reject(err)
					})
			})
		},

		async getAlreadyIngestedRef (suifa_ref, category) {
			return new Promise((resolve, reject) => {
				let params = {
					'type_sup_id': 1010,
					'ref_materiel': suifa_ref,
					'category': category
				}
				this.$apiPublic.material_search(params)
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						console.error(err)
						reject(err)
					})
			})
		},

		async getBehiveAssetInfo (ref) {
			this.form.parameters.server_storage = this.storage_list[1]
			let refSuifa = (ref || '').replace(/(_|-|\/|\\)/g, '/')
			refSuifa = refSuifa.replace(/(\t|\s+)/g, '')
			this.form.parameters.suifa_ref = refSuifa

			if (refSuifa.match(REF_SUIFA_REGEXP) && this.suifaInfos.ref !== ref) {
				this.suifaInfos.ref = ref
				this.suifaInfos.loading = true
				let hotRef = await this.getAlreadyIngestedRef(refSuifa, 'hot')
				let catalogRef = await this.getAlreadyIngestedRef(refSuifa, 'catalog')
				let jobExists = hotRef.concat(catalogRef)
				if (jobExists.length) {
					// if job exists in maestro
					this.suifaInfos.loading = false
					this.suifaInfos.ref = null
					this.suifaInfos.data = null
					this.errors = [`La référence '${refSuifa}' a déjà été ingestée (ou en cours d'ingest) par Maestro.`]
				} else {
					let activeAssets
					this.getAssetInfo(refSuifa)
						.then(response => {
							activeAssets = response.filter(asset => {
								return this.behiveCat.includes(asset.behive_category)
							})
							// if no active assets
							if (response.length === 0) {
								this.errors = []
								this.manifest = null
								this.errors.push(
									'Pas d\'asset en catalogue ou stockage chaud pour cette référence. ' + `${refSuifa}`
								)
								this.suifaInfos.data = {...response}
								this.suifaInfos.loading = false
								return
							}
							return activeAssets
						})
						.then(response => {
							// reindex asset before getting infos
							return response.map(asset => {
								this.$ApiNexus.reindex_asset(asset.mat_id)
							})
						})
						.then(response => {
							// wait some time because reindex takes time
							return new Promise((resolve) => {
								setTimeout(() => {
									resolve()
								}, 1500)
							})
						})
						.then(response => this.getAssetInfo(refSuifa))
						.then(response => {
							activeAssets = response.filter(asset => {
								return this.behiveCat.includes(asset.behive_category)
							})
							return activeAssets
						})
						.then(response => {
							// if we find active assets
							if (response.length > 0) {
								for (let activeAsset of response) {
									if (this.jobTypes.includes(activeAsset.type_sup.code_type_sup)) {
										this.manifest = null
										this.suifaInfos.data = {...activeAsset}
										this.errors = []
										this.getTAuxContract(this.suifaInfos.data.t_aux_proprio.t_auxiliaire)
											.then(contract => {
												// if client has catalog subscription
												if (contract) {
													if (contract.results.length > 0) {
														let hasContract = contract.results[0].has_storage_catalog
														if (hasContract) {
															this.localHasContract = true
															this.form.parameters.server_storage = this.storage_list[1]
														}
													} else {
														this.localHasContract = false
														this.form.parameters.server_storage = this.storage_list[0]
													}
												}
											})

										break
									} else if (activeAsset.type_sup && !this.jobTypes.includes(activeAsset.type_sup.code_type_sup)) {
										this.errors = []
										this.manifest = null
										this.errors.push(`Type d'asset non pris en charge. (${activeAsset.type_sup.code_type_sup})`)
										this.suifaInfos.data = {...activeAsset}
										this.suifaInfos.loading = false
									}
								}
								this.suifaInfos.loading = false
							// if no active assets
							} else {
								this.errors = []
								this.manifest = null
								this.errors.push(
									'Pas d\'asset en catalogue ou stockage chaud pour cette référence. ' + `${refSuifa}`
								)
								this.suifaInfos.data = null
								this.suifaInfos.loading = false
							}
						})
						.catch(error => {
							console.error(error)
							this.suifaInfos.ref = null
							this.suifaInfos.data = null
							this.suifaInfos.loading = false
						})
				}
			}
		},
		checkRequired (value) {
			if (value === '') return 'Requis'
			if (value === null) return 'Requis'
			if (value === undefined) return 'Requis'
			return true
		},
		checkRefSuifa (value = '') {
			if (value.match(REF_SUIFA_REGEXP)) return true
			return 'ex: 24/05/1839'
		},
		validate () {
			let isValid = this.$refs.unitary_form.validate()
			this.form.isValid = isValid
			return isValid
		},
		resetValidation () {
			return this.$refs.unitary_form.resetValidation()
		}
	},
	mounted () {
		this.init()
	}
}
</script>

<style scoped lang="stylus">
>>>.v-stepper__step__step
	height: 32px
	width: 32px
	font-weight: bold
	.v-icon
		color: var(--v-color-base) !important

>>>.v-stepper__step--inactive
	.v-stepper__step__step
		background-color: var(--v-background-lighten1) !important

.info-table
	th
		font-weight: normal
		color: var(--v-primary-base)
	th
	td
		padding: 2px 6px
</style>



// WEBPACK FOOTER //
// src/pages/maestro/launcher/forms/launcher_form_dvd_bd.vue